






































import { Component, Vue, Watch, Prop } from "vue-property-decorator";

import Cart from "@/views/Order/Cart.vue";
import { Getter, Action, Mutation } from "vuex-class";
import billingAPI from "@/services/billing";
import accountsAPI from "@/services/accounts";
import OrderHelpers, { Order } from "@/models/order";
import loader from "@/components/loader.vue";
import { Address } from "../../models/address";
import { Account } from "../../models/account";
import { Package } from "../../models/package";
import { debounce, cancel } from "typescript-debounce-decorator";
import { ServiceMatrix } from "@/models/serviceMatrix";
import AddressView from "@/components/AddressView.vue";
import { Warehouse } from "@/models/warehouse";
@Component({
  components: {
    Cart,
    loader,
    AddressView
  },
})
export default class OrderView extends Vue {
  public loading: string | boolean = false;
  @Prop({ default: {} }) public order!: Order;

  @Getter("serviceMatrix") serviceMatrix!: ServiceMatrix[];
  get services() {
    return this.serviceMatrix.find(
      (mtix) => mtix.id === this.order!.service_matrix_id
    ) || { warehouse_id: 0 };
  }

  @Getter("warehouses") warehouses!: Warehouse[];
  get warehouse() {
    if (!this.order) return { id: 0 };
    return (
      this.warehouses.find(
        (wh) => wh.id === this.services!.warehouse_id
      ) || { id: 0 }
    );
  }
}
